export const getWorkScheduleState = (state: any) => state.workSchedule
